import React, { useEffect, useState } from "react"
import { StyledFooter } from "./footerComponents";
import { FooterMobile } from "./footerComponents";
import { Year } from "./linkTreeComponents";

const Footer = (props) => {

    var isMobile = false;

    if(typeof window !== `undefined`){
        
        if(window.screen.width < 1024){
          isMobile = true;
        }else{
          isMobile = false;
        }
      }

  const buildLocation = () => {
      
        if(isMobile){
            return (
                <>
                    <span style={{marginLeft: "8px"}}>
                        Caracas - Venezuela 
                    </span>
                </>
            );
        }else{

            return (
                <>
                    <span style={{marginLeft: "8px"}}>
                        Caracas - Venezuela. 
                    </span>
                </>
            );
        }

    }

    return (
        <>
            <StyledFooter>
                <FooterMobile>
                    <div className="col-info">
                        <span className="information">
                            © Copyright {Year} <b style={{fontSize: "12px"}}>{props.info}</b>
                        </span>

                        {buildLocation()}

                        <span className="policy">
                            <a href="https://dentalvipcaracas.com/politica-de-privacidad/">
                                {props.policy} </a> 
                        </span>
                    </div>

                    <div className="col-rif">
                        <span style={{fontSize: "12px"}}>
                            {props.rif}
                        </span>
                    </div>
                </FooterMobile>
            </StyledFooter>
        </>
    );

};


export default Footer;

